import axios from 'axios';
import {
    DELETE_TOUR_MODEL,
    GET_TOUR_MODEL,
    GET_TOUR_MODELS,
    POST_TOUR_MODEL,
    UPDATE_TOUR_MODEL,
    UPDATE_TOUR_MODEL_CUSTOMERS,
} from '../routes';

export default {
    async all(options = {}) {
        return await axios.get(GET_TOUR_MODELS, options);
    },
    async get(tour_model, options = {}) {
        return await axios.get(GET_TOUR_MODEL(tour_model), options);
    },
    async create(data, options = {}) {
        return await axios.post(POST_TOUR_MODEL, data, options);
    },
    async update(tour_model, data, options = {}) {
        return await axios.patch(UPDATE_TOUR_MODEL(tour_model), data, options);
    },
    async delete(tour_model, options = {}) {
        return await axios.delete(DELETE_TOUR_MODEL(tour_model), options);
    },
    async customers(tour_model, data, options = {}) {
        return await axios.put(UPDATE_TOUR_MODEL_CUSTOMERS(tour_model), data, options)
    },
    async get_customers(tour_model, data, options = {}) {
        return await axios.get(UPDATE_TOUR_MODEL_CUSTOMERS(tour_model), data, options)
    }
};
